/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Price_HigherInputs */

const en_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating this booking will increase its price. A supplementary invoice for the difference will be automatically generated and emailed to the visitor.`)
};

const de_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du diese Buchung aktualisierst, steigt ihr Preis. Eine Zusatzrechnung über die Differenz wird automatisch erstellt und dem Besucher per E-Mail zugesandt.`)
};

const es_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar esta reserva aumentará su precio. Se generará automáticamente una factura complementaria por la diferencia y se enviará por correo electrónico al visitante.`)
};

const fr_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La modification de cette réservation augmentera son prix. Une facture complémentaire pour la différence sera automatiquement générée et envoyée par e-mail au visiteur.`)
};

const nl_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bijwerken van deze reservering verhoogt de prijs. Een aanvullende factuur voor het verschil wordt automatisch gegenereerd en per e-mail naar de bezoeker gestuurd.`)
};

const it_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'aggiornamento di questa prenotazione ne aumenterà il prezzo. Una fattura integrativa per la differenza verrà generata automaticamente e inviata via email al visitatore.`)
};

const pt_br2_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar esta reserva aumentará seu preço. Uma fatura complementar pela diferença será gerada automaticamente e enviada por e-mail ao visitante.`)
};

const pl_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizacja tej rezerwacji zwiększy jej cenę. Faktura uzupełniająca na różnicę zostanie automatycznie wygenerowana i wysłana e-mailem do gościa.`)
};

const hu_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foglalás módosítása növelni fogja az árát. A különbözetről automatikusan kiegészítő számla készül, és e-mailben elküldésre kerül a látogatónak.`)
};

const ro_admin_external_booking_edit_price_higher = /** @type {(inputs: Admin_External_Booking_Edit_Price_HigherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizarea acestei rezervări va crește prețul. O factură suplimentară pentru diferență va fi generată automat și trimisă prin e-mail vizitatorului.`)
};

/**
* | output |
* | --- |
* | "Updating this booking will increase its price. A supplementary invoice for the difference will be automatically generated and emailed to the visitor." |
*
* @param {Admin_External_Booking_Edit_Price_HigherInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_price_higher = /** @type {((inputs?: Admin_External_Booking_Edit_Price_HigherInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Price_HigherInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_price_higher(inputs)
	if (locale === "de") return de_admin_external_booking_edit_price_higher(inputs)
	if (locale === "es") return es_admin_external_booking_edit_price_higher(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_price_higher(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_price_higher(inputs)
	if (locale === "it") return it_admin_external_booking_edit_price_higher(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_price_higher(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_price_higher(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_price_higher(inputs)
	return ro_admin_external_booking_edit_price_higher(inputs)
});
export { admin_external_booking_edit_price_higher as "admin.external_booking_edit.price_higher" }